function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C2.18182 0 0 6 0 6C0 6 2.18182 12 8 12C13.8182 12 16 6 16 6C16 6 13.8182 0 8 0ZM8 1.5C11.8371 1.5 13.7779 4.70032 14.4062 5.99707C13.7772 7.28482 11.8218 10.5 8 10.5C4.16291 10.5 2.22211 7.29968 1.59375 6.00293C2.22357 4.71518 4.17818 1.5 8 1.5ZM8 3C6.39345 3 5.09091 4.34325 5.09091 6C5.09091 7.65675 6.39345 9 8 9C9.60655 9 10.9091 7.65675 10.9091 6C10.9091 4.34325 9.60655 3 8 3ZM8 4.5C8.80364 4.5 9.45455 5.17125 9.45455 6C9.45455 6.82875 8.80364 7.5 8 7.5C7.19636 7.5 6.54545 6.82875 6.54545 6C6.54545 5.17125 7.19636 4.5 8 4.5Z",
  fill: "white"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.6b24504e.svg";
export { ForwardRef as ReactComponent };